import React, { useContext } from "react";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import { CartContext } from "../../../context/CartItems";
import styles from "./NotificationIcon.module.css";
export default function CartIcon(props) {
  const { cartItems } = useContext(CartContext);
  return (
    <>
      <span
        // className="material-icons fw-bold ms-2 shopping"
        className={`material-icons fw-bold ms-2 ${styles.notifyIcon}`}
        id="icon"
        onClick={() => props.handleCartlist()}
      >
        shopping_cart
        {cartItems?.length > 0 && (
          <CircleRoundedIcon
            sx={{
              border: "1px solid #fff",
              borderRadius: "50%",
              width: "0px",
              // boxSizing: 'border-box',
            }}
            className="CircleRoundedIcon"
          ></CircleRoundedIcon>
        )}
      </span>

      {/* <span id="number" onClick={() => props.handleCartlist()}>
        Cart
      </span> */}
    </>
  );
}
